import React from "react";
import { useLocation } from "react-router-dom";
import SponsoredAd from "./SponsoredAd";

/**
 * Reads the current pathname and picks the appropriate sponsor placement.
 * The backend also accepts "all", so a sponsor with placement=all matches every page.
 * Placements returned to backend: homepage | job_listing | job_details | all
 * Pages where we don't want to show ads: login, register, admin, dashboards, inbox.
 */
export default function RouteSponsoredAd() {
  const { pathname } = useLocation();

  // Hide on private pages / auth pages entirely
  const suppressed = [
    "/login", "/register", "/inbox", "/candidate", "/employer",
    "/employer/post", "/admin",
  ].some((p) => pathname === p || pathname.startsWith(p + "/"));
  if (suppressed) return null;

  let placement = "all";
  if (pathname === "/") placement = "homepage";
  else if (pathname === "/jobs" || pathname.startsWith("/jobs/category/") || pathname.startsWith("/jobs/location/") || pathname === "/jobs/categories" || pathname === "/jobs/locations") placement = "job_listing";
  else if (pathname.startsWith("/jobs/") || pathname.startsWith("/career/")) placement = "job_details";

  // key by pathname so a route change fetches a fresh sponsor
  return <SponsoredAd key={pathname} placement={placement} />;
}
